module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label-tag', {
    attrs: {
      "tagArray": [_vm.$t('conversation_mission')],
      "previous": true
    },
    on: {
      "previousPage": _vm.goVrIndex
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-5 ",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentScene),
      expression: "currentScene"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentScene = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sceneList), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.goPage(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "m-5",
    staticStyle: {
      "overflow": "auto",
      "min-height": "50vh"
    }
  }, [_c('table', {
    staticClass: "table table-borderless table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('scene')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('character')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('chance')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('standard_score')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('mistake')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('display')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('function')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "border-top": "1px #cccccc solid",
      "border-bottom": "1px #cccccc solid"
    }
  }, _vm._l((_vm.dialogsInfo), function(el, index) {
    return _c('tr', {
      key: index
    }, [_c('th', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (el.title),
        expression: "el.title"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('input_name')
      },
      domProps: {
        "value": (el.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(el, "title", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('v-select', {
      staticStyle: {
        "min-width": "200px"
      },
      attrs: {
        "reduce": function (title) { return title.value; },
        "options": _vm.options,
        "label": _vm.locale === 'tw' ? 'text' : 'textEn'
      },
      scopedSlots: _vm._u([{
        key: "option",
        fn: function(option) {
          return [(_vm.locale === 'tw') ? _c('div', {
            staticClass: "d-flex"
          }, [_c('div', {
            staticStyle: {
              "width": "50%"
            }
          }, [_vm._v("\n                      " + _vm._s(option.title) + "\n                    ")])]) : _c('div', {
            staticClass: "d-flex"
          }, [_c('div', {
            staticStyle: {
              "width": "50%"
            }
          }, [_vm._v("\n                      " + _vm._s(option.textEn) + "\n                    ")])]), _vm._v(" "), _c('div', {
            staticStyle: {
              "width": "80%"
            }
          }, [_c('img', {
            staticStyle: {
              "width": "125px"
            },
            attrs: {
              "src": option.image
            }
          })])]
        }
      }], null, true),
      model: {
        value: (el.situationId),
        callback: function($$v) {
          _vm.$set(el, "situationId", $$v)
        },
        expression: "el.situationId"
      }
    })], 1), _vm._v(" "), _c('td', [(_vm.sceneInfo) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (el.roleId),
        expression: "el.roleId"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(el, "roleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.sceneInfo.roles), function(item, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": item.value
        }
      }, [(_vm.locale === 'tw') ? _c('span', [_vm._v(_vm._s(item.text))]) : _c('span', [_vm._v(_vm._s(item.textEn))])])
    }), 0) : _vm._e()]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (el.repetTimes),
        expression: "el.repetTimes"
      }],
      attrs: {
        "min": "0",
        "max": "99",
        "type": "number",
        "name": "",
        "id": ""
      },
      domProps: {
        "value": (el.repetTimes)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(el, "repetTimes", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (el.passScore),
        expression: "el.passScore"
      }],
      attrs: {
        "min": "0",
        "max": "99",
        "type": "number",
        "name": "",
        "id": ""
      },
      domProps: {
        "value": (el.passScore)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(el, "passScore", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (el.failedCutScore),
        expression: "el.failedCutScore"
      }],
      attrs: {
        "min": "0",
        "max": "99",
        "type": "number",
        "name": "",
        "id": ""
      },
      domProps: {
        "value": (el.failedCutScore)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(el, "failedCutScore", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('toggle-button', {
      attrs: {
        "sync": true,
        "labels": {
          checked: 'On',
          unchecked: 'Off'
        },
        "color": {
          checked: '#5dceb0',
          unchecked: '#6e817f'
        },
        "disabled": _vm.enableCount === 5 && !el.isEnable
      },
      model: {
        value: (el.isEnable),
        callback: function($$v) {
          _vm.$set(el, "isEnable", $$v)
        },
        expression: "el.isEnable"
      }
    })], 1), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "pointer control-btn",
      on: {
        "click": function($event) {
          return _vm.goEditPage(el)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('edit')))]), _vm._v(" "), _c('span', {
      staticClass: "pointer control-btn",
      on: {
        "click": function($event) {
          return _vm.removeCustomDialogs(el)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('delete')))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addConversation
    }
  }, [_vm._v(_vm._s(_vm.$t('add')))])])]), _vm._v(" "), _c('div', {
    staticClass: "mx-5",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addCustomDialogs
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-409dcfca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/vr/ConversationMission.vue
// module id = 779
// module chunks = 3